// eslint-disable-next-line import/prefer-default-export
export const TITLE_PREFIX = 'Niqola |';
